export const AccountActionTypes = {
    API_RESPONSE_SUCCESS: '@@email_accounts/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@email_accounts/API_RESPONSE_ERROR',

    GET_ACCOUNTS: '@@email_accounts/GET_ACCOUNTS',
    GET_ACCOUNT_BY_ID: '@@email_accounts/GET_ACCOUNT_BY_ID',
    GET_ACCOUNTS_BY_USER: '@@email_accounts/GET_ACCOUNTS_BY_USER',
    GET_ACCOUNTS_BY_ORGANIZATION: '@@email_accounts/GET_ACCOUNTS_BY_ORGANIZATION',
    GET_ACCOUNT_ACCESS: '@@email_accounts/GET_ACCOUNT_ACCESS',
    REVOKE_ACCOUNT_ACCESS: '@@email_accounts/REVOKE_ACCOUNT_ACCESS',
    CREATE_ACCOUNT: '@@email_accounts/CREATE_ACCOUNT',
    UPDATE_ACCOUNT: '@@email_accounts/UPDATE_ACCOUNT',
    DELETE_ACCOUNT: '@@email_accounts/DELETE_ACCOUNT',
    RESET_ACCOUNTS: '@@email_accounts/RESET_ACCOUNTS',
    SEND_ACCOUNT_EMAIL: '@@email_accounts/SEND_ACCOUNT_EMAIL',
};
